import nprogress from 'nprogress';
import {
  getToken,
  removeToken,
  removeMainListMode,
  removeDetailInfoMode,
  removeIsFather,
  removeIsPicture,
  removeIsDialog
} from '@/utils/token';
import { useUserStore } from '@/store/user';
import { useRouteStore } from '@/store/route';
import { Settings } from '@/settings';
import { replaceQuery } from '@/utils/utils';
import fileServices from '@/services/file.services';
import router from '.';
import 'nprogress/nprogress.css';

nprogress.configure({ showSpinner: false, speed: 300 });
const accessList = ['/login', '/auth', '/401', '/403', '/public-download', '/public'];

router.beforeEach(async (to, _from, next) => {
  nprogress.start();
  document.title = [to.meta?.title, Settings.projectName].filter(Boolean).join(' - ');

  const userStore = useUserStore();
  const routeStore = useRouteStore();
  // 取出sessionStorage中的token
  const token = getToken();

  // 有token
  if (token) {
    // 已经获取到用户信息
    if (userStore.accountId) {
      if (accessList.includes(to.path)) {
        // 防止重复进入授权页
        next();
      } else {
        next();
        // const ossUrl = to.query?.detail ?? '';
        // if (to.path === '/space/index') {
        //   if (ossUrl) {
        //     try {
        //       fileServices.checkFileUrl({ ossUrl }).then(res => {
        //         if (res.isOK) {
        //           if (!res.data) {
        //             next({ path: '/403' });
        //           } else {
        //             next();
        //           }
        //         } else {
        //           next({ path: '/403' });
        //         }
        //       });
        //     } catch (error) {
        //       console.log(error);
        //     }
        //   } else {
        //     next();
        //   }
        // } else {
        //   next();
        // }
      }
    } else {
      try {
        // 未获取用户信息，获取用户信息
        await userStore.getSetup();

        // 根据权限过滤路由
        // let currentRole = '';
        // if (!userStore.isSupperAdmin) currentRole = 'ordinaryUser';
        // else currentRole = userStore.isShowBack ? 'analyseAdmin' : 'supperAdmin';
        // if (userStore.isExternalUser) currentRole = 'externalUser';
        const currentRole = [];
        if (userStore.isSupperAdmin) currentRole.push('supperAdmin');
        else if (userStore.isExternalUser) currentRole.push('externalUser');
        else currentRole.push('ordinaryUser');
        if (userStore.isShowBack) currentRole.push('analyseAdmin');
        if (userStore.isExternalAdmin) currentRole.push('externalAdmin');
        await routeStore.generateRoutes(currentRole);
        // 在路由器中添加动态路由
        routeStore.routes.forEach(route => router.addRoute(route));

        next({ ...to, replace: true });
      } catch (error) {
        // 出错移除本地token
        console.log(error);
        removeToken();
        removeMainListMode();
        removeIsFather();
        removeIsPicture();
        removeDetailInfoMode();
        removeIsDialog();
        next(getAuthRoute(to));
      }
    }
  } else if (accessList.includes(to.path)) {
    // 防止重复进入授权页
    next();
  } else {
    if (to.path === '/external-space/index' || to.path === '/external-share') {
      next({
        path: 'login',
        query: {
          redirect: replaceQuery(to.fullPath, 'code')
        }
      });
    } else {
      // 未授权
      next(getAuthRoute(to));
    }
  }
});

router.afterEach(() => {
  nprogress.done();
});

const getAuthRoute = to => {
  const { code } = to.query;
  return {
    path: '/auth',
    query: {
      code,
      redirect: replaceQuery(to.fullPath, 'code')
    }
  };
};
